export default {
  address: {
    line1: "2828 Laurier Boulevard, Suite 700",
    line2: "Québec, QC G1V 0B9",
    country: "Canada",
  },
  seo: {
    title: "Consultants Succès Inc | Business Financing in Quebec City",
    description: "Business financing in Quebec City since 2016: working capital, corporate credit cards and real estate project financing. Consultants Succès Inc — Vladimir Blain, Lead Consultant.",
  },
  nav: {
    services: "Services",
    solutions: "Solutions",
    approche: "Approach",
    consultant: "Consultant",
    faq: "FAQ",
    contact: "Contact",
    vytali: "Discover Vytali",
    apply: "Start an application",
    portal: "Access my account",
    impact: "Social Impact",
    ariaMenu: "Menu",
    ariaChangeLang: "Change language",
  },
  impactHome: {
    eyebrow: "Social Impact",
    title: "Success that creates impact",
    text: "Alongside our financing and entrepreneur support activities, Consultants Succès also takes part in selected social, community and charitable initiatives with committed partners.",
    cta: "Discover our social impact",
  },
  impact: {
    seoTitle: "Social Impact | Consultants Succès",
    seoDesc: "Discover Consultants Succès' social and community commitment and the initiatives we support alongside committed partners.",
    heroTitle: "Success means even more when it creates a positive impact.",
    heroSubtitle: "Consultants Succès takes part in social, community and charitable initiatives designed to contribute positively to the communities around us.",
    heroCta1: "Discover our initiatives",
    heroCta2: "Contact us",
    engagementTitle: "Our commitment",
    engagementParas: [
      "At Consultants Succès, we believe economic growth and positive human impact can move forward together.",
      "Our core business remains focused on supporting entrepreneurs, business financing and project financing.",
      "At the same time, we take part in selected social, community and charitable initiatives alongside committed partners.",
      "Our goal is to help create positive outcomes beyond business.",
    ],
    howTitle: "How we contribute",
    howItems: [
      { title: "Community initiatives", text: "Taking part in initiatives designed to support and mobilize communities." },
      { title: "Charitable campaigns", text: "Collaborating on selected charitable campaigns alongside committed partners and organizations." },
      { title: "Partner mobilization", text: "Building bridges between businesses, partners and initiatives that create positive impact." },
      { title: "Events and awareness", text: "Taking part in events and actions that raise awareness, mobilize and bring people together." },
    ],
    initiativesTitle: "Our initiatives",
    initiativesCardTitle: "Initiatives that grow with our commitment",
    initiativesCardText: "Consultants Succès takes part in and will continue to support selected social and community initiatives. Campaigns and projects approved for public communication will be presented here over time.",
    participateItems: [
      { title: "Take part", text: "Discover the initiatives and activities Consultants Succès takes part in." },
      { title: "Collaborate", text: "Businesses, partners and organizations can reach out to explore potential collaborations." },
      { title: "Support", text: "When specific campaigns allow it, participation and support details will be clearly displayed." },
    ],
    transparencyTitle: "A transparent approach",
    transparencyParas: [
      "Consultants Succès may take part in campaigns, events or initiatives in collaboration with various partners or organizations. Whenever donations or financial contributions are associated with an initiative, the applicable terms and the beneficiary organization must be clearly identified.",
      "Consultants Succès is not a registered charity.",
    ],
  },
  hero: {
    kicker: "Business financing — Quebec City, since 2016",
    lines: ["The capital you need,", "right when", "it counts."],
    subtitle: "Working capital, business credit and real estate projects. Consultants Succès Inc guides Quebec entrepreneurs toward the financing that moves their projects forward.",
    primaryCta: "Plan my financing strategy",
    vytaliCta: "Discover Vytali",
  },
  trust: {
    tagline: "More solutions. More possibilities.",
    taglineGold: "More growth.",
    items: [
      { title: "Network of specialized lenders", desc: "Access multiple financing solutions tailored to your business." },
      { title: "Fast file analysis", desc: "We review your request to identify the best options available." },
      { title: "Personalized guidance", desc: "An advisor supports you at every step until you secure your financing." },
    ],
  },
  stats: {
    heading: "A decade of measurable",
    headingGold: "results",
    sub: "\u201cRookie of the Year\u201d in 2017, one year after our founding. We never slowed down.",
    labels: ["Founded in March", "Managers promoted", "Gala awards won", "Employees trained"],
  },
  marquee: {
    items: ["CONSULTANTS SUCCÈS INC", "FINANCING", "STRATEGY", "RESULTS", "QUEBEC", "SINCE 2016"],
  },
  services: {
    kicker: "Our services",
    heading: "Three levers to finance your ambition",
    discuss: "Let's talk",
    items: [
      { title: "Business financing", desc: "Get the working capital you need to stabilize your operations, seize opportunities and support your growth without compromising your liquidity." },
      { title: "Credit cards", desc: "A credit line established in your company's name — not yours. Build your business credit and keep your personal finances separate from your company's." },
      { title: "Real estate projects", desc: "Structured financing for property acquisitions and multi-project portfolios. From your first property to a complete portfolio." },
    ],
  },
  solutions: {
    kicker: "Our financing solutions",
    heading: "A complete offer, tailored to",
    headingGold: "your reality",
    request: "Request financing",
    items: [
      { title: "Working capital", desc: "Fast capital to support your day-to-day operations and seize opportunities without waiting." },
      { title: "Equipment financing", desc: "Acquire the machinery and equipment your growth requires without tying up your cash." },
      { title: "Invoice financing", desc: "Turn your receivables into immediate cash instead of waiting 30, 60 or 90 days." },
      { title: "Commercial real estate", desc: "Structured financing for the acquisition, conversion or development of commercial properties." },
      { title: "Business credit", desc: "Build your company's credit with cards and credit lines in its name, not yours." },
      { title: "Growth and expansion", desc: "Structured capital to open a new location, hire, or reach new markets." },
    ],
  },
  etapes: {
    kicker: "Our approach",
    heading: "Four steps.",
    headingGold: "A proven method.",
    steps: [
      { title: "Market research", desc: "We analyze your industry, your competitors and your positioning to identify the most advantageous financing opportunities." },
      { title: "Informing clients", desc: "Clear, transparent communication: you understand every option and every condition before making a decision." },
      { title: "Selling", desc: "We present your file at its very best to the right institutions to maximize your chances of approval." },
      { title: "Building loyalty", desc: "The relationship doesn't end at approval. We stay by your side for your next projects and long-term growth." },
    ],
  },
  consultant: {
    kicker: "Lead Consultant",
    role: "Lead Consultant",
    heading: "Vladimir Blain, the ally of entrepreneurs who think big",
    p1: "At the helm of Consultants Succès since March 2016, Vladimir Blain has built a recognized team — \u201cRookie of the Year\u201d as early as 2017, six Gala awards, five managers promoted and more than thirty employees trained. His conviction: every business deserves clear, fast access to the capital that will make it grow.",
    p2Before: "Today, he connects financing to growth by also leading ",
    p2Brand: "Vytali Marketing",
    p2After: " — the platform that helps Quebec businesses generate and convert more clients.",
    promoBefore: "Powered by ",
    promoBrand: "Vytali",
    promoAfter: ", our business intelligence platform, for faster analysis and more precise answers to your financing requests.",
    vytaliCta: "Discover Vytali",
    writeCta: "Write to the team",
    photoAlt: "Vladimir Blain, Lead Consultant",
  },
  calc: {
    eyebrow: "Financing calculator",
    title: "Estimate your payments.",
    desc: "Explore different financing scenarios for illustrative purposes.",
    amountLabel: "Financing amount",
    termLabel: "Term",
    termUnit: "months",
    rateLabel: "Estimated annual rate",
    rateHelp: "Use an estimated rate to explore different scenarios. The actual rate will depend on the product, lender, eligibility and applicable terms.",
    illustrative: "Illustrative scenario — adjust the values to your situation.",
    resultTitle: "Estimated monthly payment",
    perMonth: "/ month",
    sumAmount: "Financing amount",
    sumTerm: "Term",
    sumRate: "Estimated rate",
    disclaimer: "This estimate is provided for informational purposes only. It is not a financing offer or approval. Actual rates, payments and terms may vary depending on the product, lender, eligibility and applicable terms.",
    cta: "Request a personalized financing review",
    contactMessage: "I would like to discuss the financing scenario I just calculated.",
    errAmount: "Enter an amount greater than 0.",
    errTerm: "Enter a term in months between 1 and 600.",
    errRate: "Enter a rate between 0 and 100.",
  },
  faq: {
    kicker: "FAQ",
    heading: "Your questions about",
    headingGold: "financing",
    sub: "Working capital, business credit, real estate — answers to the questions we hear most often.",
    items: [
      { q: "What is working capital and what is it for?", a: "Working capital is the money your business has available to cover day-to-day operations: inventory, payroll, suppliers, marketing. Working capital financing lets you seize opportunities and get through slower periods without compromising your liquidity." },
      { q: "What is the difference between a personal credit card and a business card?", a: "A business card is established in your company's name, not yours. It builds your company's credit history, separates your personal finances from the business and protects your personal credit score. It's an essential step toward accessing larger financing later on." },
      { q: "My business is young — can I still get financing?", a: "Yes. Our role is precisely to structure your file so it's presented at its best to the right institutions. Every situation is unique: write to us and together we'll assess the options suited to your stage of growth." },
      { q: "Do you finance real estate projects?", a: "Absolutely. We support property acquisitions and multi-project portfolios — from a first property to a complete portfolio. We structure the financing according to the nature of the project: acquisition, conversion or development." },
      { q: "How long does the process take?", a: "It depends on the type of financing and how prepared your file is. Our 4-step method (research, information, presentation, follow-up) is designed to speed up every phase. Contact us for a quick initial assessment of your situation." },
      { q: "Are your services limited to the Quebec City area?", a: "Our office is located in Quebec City (2828 Laurier Boulevard, Suite 700), but we support entrepreneurs across Quebec. Most steps can be completed remotely: +1 581-333-3447." },
    ],
  },
  contact: {
    kicker: "Contact",
    heading: "Let's talk about your project",
    sub: "A question about financing, business credit cards or a real estate project? Write to us — a team member will get back to you quickly.",
    nameLabel: "Full name",
    namePh: "Your name",
    phoneLabel: "Phone",
    phonePh: "E.g.: 514-555-1234",
    emailLabel: "Email",
    emailPh: "you@company.com",
    solutionLabel: "Solution of interest",
    solutionOptional: "(optional)",
    solutionPh: "E.g.: Working capital, Commercial real estate…",
    solutionSelectPh: "Select a solution…",
    messageLabel: "Your question",
    messagePh: "Describe your project or ask your question…",
    submit: "Send my question",
    sending: "Sending…",
    fillAll: "Please fill in all fields.",
    errName: "Please enter your full name.",
    errEmail: "Please enter a valid email address.",
    errPhone: "Please enter a valid phone number.",
    success: "Message sent! We'll get back to you shortly.",
    error: "Something went wrong. Please try again.",
    rateLimited: "Too many messages sent. Please try again in a few minutes.",
    mapTitle: "Consultants Succès office — 2828 Laurier Boulevard, Québec",
    mapLink: "Directions on Google Maps",
    consentNote: "By submitting this form, you are asking to be contacted by Consultants Succès Inc about your request. Your contact information is used only for this follow-up.",
  },
  footer: {
    desc: "The financial partner of Quebec businesses: business financing, corporate credit and real estate projects. Founded in March 2016.",
    coordinates: "Contact information",
    follow: "Follow us",
    vytali: "Discover Vytali",
    rights: "All rights reserved.",
    role: "Vladimir Blain — Lead Consultant",
  },
  call: {
    main: "Main office",
    quebec: "Quebec City office",
    ariaOpen: "Call Consultants Succès",
    ariaClose: "Close call menu",
  },
};
